import { useQuery } from '@tanstack/react-query'

import { encodeQueryString } from '../../../../app/queryString'
import { apiRequest } from '../../../services/api'
import { ApiPaginatedResponse } from '../../../types'
import { DEFAULT_QUERY_CACHE_TIME_IN_MS, ManagerFundItemData } from '../constants'

interface Props {
  page: number
  search?: string
  sort?: string
  initialData: ApiPaginatedResponse<ManagerFundItemData[]> | null
  shouldResetScroll?: boolean
}

export function useFundsListData({ page, search, sort, initialData, shouldResetScroll }: Props) {
  const fundsListQuery = useQuery({
    queryKey: ['fundsList', page, search, sort],
    queryFn: async () =>
      apiRequest<ApiPaginatedResponse<ManagerFundItemData[]>>(
        `/api/funds/list?${encodeQueryString({ page, search, sort })}`
      ),
    initialData: initialData ?? undefined,
    onSuccess: () => {
      if (shouldResetScroll) {
        window.scrollTo({ top: 0 })
      }
    },
    keepPreviousData: true,
    staleTime: DEFAULT_QUERY_CACHE_TIME_IN_MS,
    cacheTime: DEFAULT_QUERY_CACHE_TIME_IN_MS,
  })

  return fundsListQuery
}
